// extracted by mini-css-extract-plugin
export default {"loadingGroup":"loadingGroup--FDOFi","switch":"switch--oZA7y"};